import React, { useState, useEffect } from 'react';
import LayoutLandingHeader from '../components/LayoutLandingHeader'; 
import LayoutLandingFooter from '../components/LayoutLandingFooter'; 
import axios from 'axios';
import {
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
  Grid,
  Paper,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment
} from "@mui/material";

const ThankYou = () => {

  return (
    <div className="container">
          <>
      <LayoutLandingHeader />
      <Box sx={{ maxWidth: 1300, margin: "0 auto", padding: 4, marginTop: 4 }}>
        <Paper elevation={3} sx={{ padding: 3 }}>
          <Typography
  variant="h6"
  gutterBottom
  fontWeight="bold"
  sx={{ marginBottom: 2, textAlign: "center" }}
>
  Thank You For Registering To EasUpTax <a href="/Login" style={{ color: "#1976d2", textDecoration: "none" }}>
    please login
  </a>
</Typography>
        </Paper>
      </Box>
      <br/>
       <br/>
        <br/>
         <br/>
          <br/>
           <br/>
            <br/>
             <br/>
              <br/>
               <br/>
                <br/>
                 <br/>
                  <br/>
                   <br/>
                    <br/>
                     <br/>
                      <br/>
                       <br/>
                        <br/>
                         <br/>
                          <br/>
                           <br/>
                            <br/>
                             <br/>
      <LayoutLandingFooter />
    </>
    </div>
  );
};

export default ThankYou;

